const SecretSanta = () => import('../../components/SecretSanta/SecretSanta')

export default {
    path: 'secret-santa',
    redirect: 'secret-santa',
    component: {
        template: '<router-view></router-view>',
    },
    name: 'secret-santa',
    meta: {'permissions': 'use-secret-santa'},
    children: [
        {
            path: '/',
            component: SecretSanta,
        },
    ],
};
